import { smoothScroll } from "./smoothScroll";
export function scrollSpy(_a) {
  var selector = _a.selector,
      _b = _a.offset,
      offset = _b === void 0 ? 10 : _b,
      _c = _a.cachingHeadings,
      cachingHeadings = _c === void 0 ? true : _c,
      _d = _a.enableSmoothScroll,
      enableSmoothScroll = _d === void 0 ? false : _d,
      pushStateBehavior = _a.pushStateBehavior,
      callback = _a.callback;
  var headingsCache;
  var timer;

  var findHeadings = function findHeadings() {
    if (cachingHeadings && headingsCache) {
      return headingsCache;
    }

    return document.querySelectorAll(selector);
  };

  function onScroll() {
    if (timer) {
      // throttle
      return;
    }

    timer = setTimeout(function () {
      timer = null;
      var activeNavFound = false;
      var headings = findHeadings();

      for (var i = 0; i < headings.length; i++) {
        var currNavActive = !activeNavFound;

        if (currNavActive && i < headings.length - 1) {
          var heading = headings[i + 1];

          if (!heading.href) {
            return null;
          }

          var next = decodeURIComponent(heading.href.split("#")[1]);
          var nextHeader = document.getElementById(next);

          if (nextHeader) {
            var top_1 = nextHeader.getBoundingClientRect().top;
            currNavActive = top_1 > offset;
          } else {
            console.error("Can not find header element", {
              id: next,
              heading: heading
            });
          }
        }

        if (currNavActive) {
          activeNavFound = true;
          headings[i].classList.add("active");
          callback && callback(headings[i]);
        } else {
          headings[i].classList.remove("active");
        }
      }

      return;
    }, 0);
  }

  function domContentLoaded() {
    headingsCache = findHeadings();
    onScroll();
  }

  function addListeners() {
    document.addEventListener("scroll", onScroll);
    document.addEventListener("resize", onScroll);
    document.addEventListener("DOMContentLoaded", domContentLoaded);
  }

  function removeListeners() {
    document.removeEventListener("scroll", onScroll);
    document.removeEventListener("resize", onScroll);
    document.removeEventListener("DOMContentLoaded", domContentLoaded);
  }

  addListeners();
  smoothScroll({
    enableSmoothScroll: enableSmoothScroll,
    pushStateBehavior: pushStateBehavior
  });
  onScroll();
  return removeListeners;
}